export { default } from './DetailsCard';
export * from './DetailsCard';
